import { call, put, takeLatest, select } from 'redux-saga/effects';
import systemBackupService from '../../../services/systemBackupService';
import {
  fetchBackupConfigRequest,
  fetchBackupConfigSuccess,
  fetchBackupConfigFailure,
  saveBackupConfigRequest,
  saveBackupConfigSuccess,
  saveBackupConfigFailure,
  manualBackupRequest,
  manualBackupSuccess,
  manualBackupFailure,
  fetchBackupLogsRequest,
  fetchBackupLogsSuccess,
  fetchBackupLogsFailure,
  selectBackupLogsPage,
  selectBackupLogsSize,
  selectFilterFromDate,
  selectFilterToDate,
  restoreBackupRequest,
  restoreBackupSuccess,
  restoreBackupFailure,
} from './slice';

function* handleFetchBackupConfig() {
  try {
    const response = yield call(systemBackupService.getBackupConfig);
    yield put(fetchBackupConfigSuccess(response));
  } catch (error) {
    // If not found or error, set config to null (will clear the form)
    yield put(fetchBackupConfigFailure(error.message || 'Failed to fetch backup config'));
  }
}

function* handleSaveBackupConfig(action) {
  try {
    const response = yield call(systemBackupService.saveBackupConfig, action.payload);
    yield put(saveBackupConfigSuccess(response));
  } catch (error) {
    yield put(saveBackupConfigFailure(error.message || 'Failed to save backup config'));
  }
}

function* handleManualBackup() {
  try {
    const response = yield call(systemBackupService.manualBackup);
    yield put(manualBackupSuccess(response));
  } catch (error) {
    yield put(manualBackupFailure(error.message || 'Failed to trigger manual backup'));
  }
}

function* handleFetchBackupLogs(action) {
  try {
    const page = action.payload?.page || (yield select(selectBackupLogsPage));
    const size = action.payload?.size || (yield select(selectBackupLogsSize));
    const fromDate = yield select(selectFilterFromDate);
    const toDate = yield select(selectFilterToDate);

    const params = { page, size };

    // fromDate: DateTime? - convert to ISO datetime (start of day)
    if (fromDate) {
      params.fromDate = `${fromDate}T00:00:00`;
    }
    // toDate: DateTime? - convert to ISO datetime (end of day)
    if (toDate) {
      params.toDate = `${toDate}T23:59:59`;
    }

    const response = yield call(systemBackupService.getBackupLogs, params);
    yield put(fetchBackupLogsSuccess(response));
  } catch (error) {
    yield put(fetchBackupLogsFailure(error.message || 'Failed to fetch backup logs'));
  }
}

function* handleRestoreBackup(action) {
  try {
    const response = yield call(systemBackupService.restoreBackup, action.payload);
    yield put(restoreBackupSuccess(response));
    // Refresh backup logs after restore
    const page = yield select(selectBackupLogsPage);
    const size = yield select(selectBackupLogsSize);
    yield put(fetchBackupLogsRequest({ page, size }));
  } catch (error) {
    yield put(restoreBackupFailure(error.message || 'Failed to restore backup'));
  }
}

export function* watchSystemBackupActions() {
  yield takeLatest(fetchBackupConfigRequest.type, handleFetchBackupConfig);
  yield takeLatest(saveBackupConfigRequest.type, handleSaveBackupConfig);
  yield takeLatest(manualBackupRequest.type, handleManualBackup);
  yield takeLatest(fetchBackupLogsRequest.type, handleFetchBackupLogs);
  yield takeLatest(restoreBackupRequest.type, handleRestoreBackup);
}
